import React from 'react';
/* eslint-disable import/no-extraneous-dependencies */
import Box from '@mui/material/Box';
import Button from '@digital-hig/button';
import Typography from '@digital-hig/typography';
import { useTranslation } from 'react-i18next';
import FeedbackRootElement from './style';

const Feedback = () => {
  const { t } = useTranslation();
  const askAutodeskAssistant = () => {
    if (
      window.adskUniversalHelpOptionsGlobal
            && window.adskUniversalHelpOptionsGlobal?.adskUpdateUHMOptions
    ) {
      window.adskUniversalHelpOptionsGlobal.adskUpdateUHMOptions({
        deepLinkToValue: 'start',
        contextualLinkOrigin: 'open-ua',
      });
    }
  };

  return (
    <FeedbackRootElement>
      <Box className="page-container">
        <Box className="feedback-section">
          <Box className="feedback-left">
            <Typography
              variant="headline-large"
              className="feedback-title"
              component="h3"
            >
              {t('Need help? Contact us.')}
            </Typography>
            <Typography className="feedback-desc">
              {t('Contact Partner Finder for help using the online search tool and more. The Autodesk Assistant can help with Autodesk products, answer questions, or send you to an agent.')}
            </Typography>
          </Box>
          <Box className="dhig-theme--dark feedback-right">
            <Button
              data-wat-loc="subfooter"
              data-wat-val="contact partner finder"
              className="contact-partner"
              variant="contained"
              href="mailto:partner.finder@autodesk.com"
            >
              {t('Contact Partner Finder')}
            </Button>
            <Button
              data-wat-loc="subfooter"
              data-wat-val="open autodesk assistant"
              variant="outlined"
              className="ask-button"
              onClick={askAutodeskAssistant}
            >
              {t('Ask Autodesk Assistant')}
            </Button>
          </Box>
        </Box>
      </Box>
    </FeedbackRootElement>
  );
};

export default Feedback;
